/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneSiteQuery = gql`
  query Site($id: ID!) {
    data: Site(id: $id) {
      id
      name
      postCode
      project {
        id
        name
        organisation {
          id
        }
      }
      location {
        lat
        lng
      }
      statistics {
        numberOfTowers
        numberOfBuilders
        numberOfApprovers
      }
    }
  }
`;
